import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProductManualRecommendationEntity } from '@product/const/v2';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ProductManualRecommendationActions } from '../store/actions';
import { StateWithProductRecommendations } from '../store/product-recommendations-state';
import { ProductManualRecommendationSelectors } from '../store/selectors';

@Injectable({ providedIn: 'root' })
export class ProductManualRecommendationService {
  private lastLoadedProductCode: string | null = null;

  constructor(private store: Store<StateWithProductRecommendations>) {}

  loadProductManualRecommendation(productCode: string): void {
    if (this.lastLoadedProductCode === productCode) {
      return;
    }

    this.lastLoadedProductCode = productCode;
    this.store.dispatch(new ProductManualRecommendationActions.ProductManualRecommendationLoad(productCode));
  }

  getProductManualRecommendationState(): Observable<StateUtils.LoaderState<ProductManualRecommendationEntity>> {
    return this.store.select(ProductManualRecommendationSelectors.getProductManualRecommendationState);
  }

  getProductManualRecommendation(): Observable<ProductManualRecommendationEntity> {
    return this.store.select(ProductManualRecommendationSelectors.getProductManualRecommendationValue);
  }

  getProductManualRecommendationLoading(): Observable<boolean> {
    return this.store.select(ProductManualRecommendationSelectors.getProductManualRecommendationLoading);
  }

  getProductManualRecommendationError(): Observable<boolean> {
    return this.store.select(ProductManualRecommendationSelectors.getProductManualRecommendationError);
  }

  getProductManualRecommendationSuccess(): Observable<boolean> {
    return this.store.select(ProductManualRecommendationSelectors.getProductManualRecommendationSuccess);
  }
}
